module.exports = __webpack_public_path__ + "img/general-infos.c51405bf.svg";